import React, { useEffect, useState } from "react";
import { X, Smartphone, Share } from "lucide-react";

const KEY = "ta_install_hint_done";

const isStandalone = () =>
  window.matchMedia?.("(display-mode: standalone)")?.matches || window.navigator.standalone === true;

const isIos = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent);

export const InstallBanner = () => {
  const [show, setShow] = useState(false);
  const [deferred, setDeferred] = useState(null);
  const [ios, setIos] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(KEY) || isStandalone()) return;
    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
      setShow(true);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);
    let timer;
    if (isIos()) {
      timer = setTimeout(() => {
        setIos(true);
        setShow(true);
      }, 5000);
    }
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      clearTimeout(timer);
    };
  }, []);

  const dismiss = () => {
    localStorage.setItem(KEY, "1");
    setShow(false);
  };

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice.catch(() => {});
    dismiss();
  };

  if (!show) return null;

  return (
    <div
      data-testid="install-banner"
      className="fixed bottom-0 inset-x-0 z-[60] p-3 sm:p-4 animate-in slide-in-from-bottom duration-500"
    >
      <div className="max-w-xl mx-auto flex items-center gap-3 p-4 shadow-2xl" style={{ backgroundColor: "#0B0B0C", border: "1px solid #3f3f46" }}>
        <span className="shrink-0 h-10 w-10 flex items-center justify-center bg-brand-red">
          <Smartphone className="h-5 w-5 text-white" />
        </span>
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold" style={{ color: "#fff" }}>Get the Tassie Automotive app</p>
          {ios ? (
            <p className="text-xs mt-0.5" style={{ color: "#a1a1aa" }}>
              Tap <Share className="inline h-3.5 w-3.5 -mt-0.5" /> Share, then <strong style={{ color: "#e4e4e7" }}>&ldquo;Add to Home Screen&rdquo;</strong> — book services in one tap.
            </p>
          ) : (
            <p className="text-xs mt-0.5" style={{ color: "#a1a1aa" }}>Install it on your phone — book services in one tap.</p>
          )}
        </div>
        {!ios && (
          <button
            data-testid="install-banner-install"
            onClick={install}
            className="shrink-0 px-4 py-2 bg-brand-red text-white text-xs font-mono uppercase tracking-widest hover:bg-[#B91C2B]"
          >
            Install
          </button>
        )}
        <button data-testid="install-banner-dismiss" onClick={dismiss} aria-label="Dismiss" className="shrink-0 p-1.5" style={{ color: "#71717a" }}>
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};
